module.exports = __webpack_public_path__ + "img/neck-endo-mesomorph-female.a65860c2.svg";